import MicroModal from "../vendor/micromodal.js"
import CustomSelect from "../plugins/custom-select.js"

new CustomSelect()

const sectorPopup = document.getElementById("select-sector")
const dropdownConfig = {
	searchEnabled: false,
	itemSelectText: "",
	allowHTML: true
}

if (sectorPopup) {
	MicroModal.init()
	sectorPopup.addEventListener("click", function (event) {
		event.preventDefault()
		MicroModal.show("sector-select-modal")
	})
}
